export default "__VITE_ASSET__3OPBJw7D__"